<footer class="footer">
  <!-- Fila superior: navegación + WhatsApp y redes -->
  <div class="footer-top">
    <div class="footer-nav">
      <div class="nav-column">
        <a routerLink="/info/nosotros">Nosotros</a>
        <a routerLink="/info/terminos-y-condiciones">Términos y condiciones</a>
        <a routerLink="/info/politica-de-envios">Políticas de envío</a>
      </div>
      <div class="nav-column">
        <a routerLink="/info/tienda-fisica">Tienda física</a>
        <a routerLink="/info/seguimiento-pedido">Hazle seguimiento a tu pedido</a>
        <a routerLink="/info/canjea-tus-puntos">Canjea tus puntos</a>
      </div>
      <div class="nav-column">
        <a routerLink="/info/promos-y-ofertas">Promos y ofertas</a>
        <a routerLink="/info/cupones-de-descuento">Cupones de descuento</a>
      </div>
    </div>

    <div class="footer-contact">
      <a
        href="https://wa.me/51961625621?text=Hola%2C%20deseo%20información%20sobre%20los%20productos%20de%20PeruFC"
        target="_blank"
        class="whatsapp-link"
      >Deseo conversar por WhatsApp</a>
      <div class="social-icons">
        <a href="https://www.tiktok.com/@perufc.com" target="_blank"><img src="assets/svg/icon-tiktok-white.svg" alt="TikTok"></a>
        <a href="https://www.instagram.com/perufc_tienda/?hl=es" target="_blank"><img src="assets/svg/icon-instagram-white.svg" alt="Instagram"></a>
        <a href="https://www.facebook.com/p/Perufccom-61579544252122/" target="_blank"><img src="assets/svg/icon-facebook-white.svg" alt="Facebook"></a>
      </div>
    </div>
  </div>

  <!-- Fila media: logo + comercio electrónico + métodos de pago -->
  <div class="footer-middle">
    <div class="footer-brand">
      <div class="footer-logo">
        <a routerLink="/">
          <img class="PeruFC" src="/assets/images/img-footer.png" alt="PeruFC" />
        </a>
      </div>
      <p class="brand-info">
        Es un comercio electrónico de<br>
        Tienda PeruFC SAC - RUC:20616128133
      </p>
    </div>

    <div class="payment-methods">
      <img class="visa" src="assets/svg/icon-visa.svg" alt="Visa">
      <img src="assets/svg/icon-master.svg" alt="Mastercard">
      <img src="assets/svg/icon-american.svg" alt="American Express">
      <img src="assets/svg/icon-dinners.svg" alt="Diners Club">
      <img src="assets/svg/icon-plin.svg" alt="Plin">
      <img src="assets/svg/icon-yape.svg" alt="Yape">
    </div>
  </div>

  <!-- Fila inferior: copyright -->
  <div class="footer-bottom">
    <p>PeruFC© todos los derechos reservados</p>
    <p>Diseñado y desarrollado por <strong>Zeventee</strong></p>
  </div>
</footer>
